export default __webpack_public_path__ + "static/media/beyondbooksorg1.21852bc8.png";